import zh_CN from "./zh-CN";
import en_US from "./en-US";

export default {
  ...zh_CN,
  ...en_US,
};
